"use client";

import type { SupSingleVaultV3 } from "@/types";
import React, { useCallback } from "react";

import useApeIn from "@/hooks/tx-flow/buttons/useApeIn";
import useDepositButton from "@/hooks/tx-flow/buttons/useDepositButton";
import { SupDepositButton, SupLoader } from "@repo/core-ui";
import UiTooltipUnsupported from "@/components/Ui/Tooltip/Unsupported";
import { useStoredDataDispatch } from "@/store/Context";
import { notifyDepositChange } from "@/utils";

interface AdapterDepositButtonProps {
  singleVault: SupSingleVaultV3;
  isFluid?: boolean;
  arrowPlacement?: "left" | "right" | "top" | "bottom";
}

export default function AdapterDepositButton({ singleVault, isFluid = false, arrowPlacement = "right" }: AdapterDepositButtonProps) {
  const storedDispatch = useStoredDataDispatch();

  const { reason, isDisabled, isCompleted, isLoading } = useDepositButton(singleVault);
  const handleApeIn = useApeIn(singleVault);

  const onClickDeposit = () => {
    storedDispatch({ vault: singleVault, type: "toggleCart" });
    notifyDepositChange(singleVault, storedDispatch);
  };

  const onClickDepositRemove = () => {
    storedDispatch({ vault: singleVault, type: "toggleCart" });
  };
  const onClickBuyNow = useCallback(() => {
    handleApeIn();
  }, [handleApeIn]);

  return isLoading ? (
    <div className="flex w-[116px] items-center justify-center">
      <SupLoader isSmall />
    </div>
  ) : (
    <UiTooltipUnsupported reason={reason} arrowPlacement={arrowPlacement} enable={isDisabled}>
      <SupDepositButton disabled={isDisabled} completed={isCompleted} onDeposit={onClickBuyNow} onBuyNow={onClickDeposit} onRemove={onClickDepositRemove} fluid={isFluid} />
    </UiTooltipUnsupported>
  );
}
